import { render, staticRenderFns } from "./gradeData.vue?vue&type=template&id=fcb874f4&scoped=true"
import script from "./gradeData.vue?vue&type=script&lang=js"
export * from "./gradeData.vue?vue&type=script&lang=js"
import style0 from "./gradeData.vue?vue&type=style&index=0&id=fcb874f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb874f4",
  null
  
)

export default component.exports